// @ts-check
// Esquema de cores Light / Dark / System por classe no <html> (doc 07, seção 15).
import { signal, effect } from '@preact/signals';
import { readStorage, writeStorage } from '../lib/utils.js';

const COLOR_SCHEME_STORAGE_KEY = 'appcrm.colorScheme';
export const COLOR_SCHEMES = /** @type {const} */ (['System', 'Light', 'Dark']);

/** @type {import('@preact/signals').Signal<'System' | 'Light' | 'Dark'>} */
export const colorSchemeState = signal(
  /** @type {any} */ (COLOR_SCHEMES.includes(/** @type {any} */ (readStorage(COLOR_SCHEME_STORAGE_KEY))) ? readStorage(COLOR_SCHEME_STORAGE_KEY) : 'System'),
);

const systemDarkQuery = window.matchMedia?.('(prefers-color-scheme: dark)');
const systemPrefersDarkState = signal(Boolean(systemDarkQuery?.matches));
systemDarkQuery?.addEventListener('change', (event) => {
  systemPrefersDarkState.value = event.matches;
});

export function startThemeEffect() {
  return effect(() => {
    const scheme = colorSchemeState.value;
    const isDark = scheme === 'Dark' || (scheme === 'System' && systemPrefersDarkState.value);
    const classList = document.documentElement.classList;
    classList.toggle('dark', isDark);
    classList.toggle('light', !isDark);
  });
}

/**
 * @param {'System' | 'Light' | 'Dark'} scheme
 */
export function setColorScheme(scheme) {
  colorSchemeState.value = scheme;
  writeStorage(COLOR_SCHEME_STORAGE_KEY, scheme);
}

export const COLOR_SCHEME_ICONS = { System: 'IconSunMoon', Light: 'IconSun', Dark: 'IconMoon' };
